import * as dotenv from 'dotenv' // see https://github.com/motdotla/dotenv#how-do-i-use-dotenv-with-import
dotenv.config();

const config = {
  urls: {
    api: process.env.REACT_APP_API_URL
  }
};

export default config;
